import React from "react";
import AppConstants from "../../../constants/AppConstants";
import When from "../../utils/When.jsx";

import CanvasCenterGuides from "./CanvasCenterGuides.jsx";
import ColumnGuides from "./ColumnGuides.jsx";
import SnapGuides from "./SnapGuides.jsx";

import styles from "./Guides.module.css";

/**
 * @typedef {import("@/utils/Snapping/FindSnapMatches").SnappingGuides} SnappingGuides
 * @typedef {typeof import("@/constants/DesignConstants.mjs").LAYOUTS[number]} Layout
 */

/**
 * Layer containing stage guides
 * @param {Object} props
 * @param {number} props.layoutWidth
 * @param {number} props.selectedBlockHeight - height of the selected block
 * @param {SnappingGuides} props.snapGuides
 * @param {Layout} props.layout
 * @param {*} props.viewState
 * @returns {import("react").ReactElement}
 */
const Guides = ({
  layoutWidth,
  selectedBlockHeight,
  snapGuides,
  layout,
  viewState,
}) => {
  const showColumnOverlay = viewState.getIn(
    ["stage", "overlays", "columnGuides"],
    false,
  );
  const showCenterGuides = viewState.getIn(
    ["stage", "overlays", "centerGuides"],
    false,
  );
  const isDesktop = layout === AppConstants.LAYOUT_DESKTOP;
  const gutterWidth = isDesktop ? 24 : 12;
  const stageWidth = isDesktop
    ? AppConstants.LAYOUT_DESKTOP_WIDTH
    : AppConstants.LAYOUT_MOBILE_WIDTH;
  const columnCount = isDesktop ? 12 : 3;
  const columnWidth =
    (stageWidth - gutterWidth * (columnCount + 1)) / columnCount;

  return (
    <>
      <When it={showColumnOverlay}>
        <ColumnGuides
          gutterWidth={gutterWidth}
          columnCount={columnCount}
          columnWidth={columnWidth}
          stageWidth={stageWidth}
        />
      </When>
      <svg
        className={styles.guideLayer}
        style={{
          "--layout-width": layoutWidth,
          "--selected-block-height": selectedBlockHeight,
        }}
      >
        <g>
          <When it={showCenterGuides}>
            <CanvasCenterGuides />
          </When>
          <SnapGuides snapGuides={snapGuides} />
        </g>
      </svg>
    </>
  );
};

export default Guides;
